export const white = '#FFFFFF'
export const grayUltraLight = '#FCFBFA'
export const grayExtraLight = '#EBECEE'
export const grayLight = '#F5F6F7'
export const gray = '#67788a'
export const grayDark = '#2D3747'
export const grayExtraDark = '#1D2330'
export const dark = '#13161F'
export const blueLight = '#e9f2fa'
export const blue = '#0026a3'
export const blueDark = '#001033'
export const skyBlue = '#1FB6FF'
export const negative = '#EB4D4B'
export const mainBg = '#f9f9f9'

export const linkHover = '#f5731e'
export const inlineCodeBg = 'rgba(255, 255, 255, 0.3)' //'#f1f1f1'